import { render, staticRenderFns } from "./CDPopularity.vue?vue&type=template&id=1c0bbbd8&scoped=true"
import script from "./CDPopularity.vue?vue&type=script&lang=ts"
export * from "./CDPopularity.vue?vue&type=script&lang=ts"
import style0 from "./CDPopularity.vue?vue&type=style&index=0&id=1c0bbbd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0bbbd8",
  null
  
)

export default component.exports